import React, { useEffect, useState } from "react";
import Dashboard from "../../../../common/Dashboard";
import AddButton from "../../../../reusable-components/buttons/AddButton";
import H2withIcon from "../../../../reusable-components/headings/H2withIcon";
import { IconContext } from "react-icons";
import { BsFillInfoCircleFill } from "react-icons/bs";
import { ABOUT_US_CONFIG_URL } from "../../../../api/api_routing_urls";
import { ToastContainer } from "react-toastify";
import showToast from "../../../../utilities/notification/NotificationModal";
import useAxiosPrivate from "../../../../authentication/hooks/useAxiosPrivate";
import ContainerShadow from "../../../../reusable-components/containers/ContainerShadow";
import AddAboutUs from "./AddAboutUs";
import useAuth from "../../../../authentication/hooks/useAuth";

const AboutUs = () => {
  const { auth } = useAuth();

  const [showAddForm, setShowAddForm] = useState(false);
  const [aboutUs, setAboutUs] = useState({});

  const axiosPrivate = useAxiosPrivate();
  const controller = new AbortController();

  const isEdit =
    aboutUs !== undefined ? Object.keys(aboutUs).length > 0 : false;

  const getAboutUsDetails = async () => {
    try {
      const response = await axiosPrivate.get(ABOUT_US_CONFIG_URL, {
        signal: controller.signal,
      });

      // let sanitized = "";
      // if (response.data.aboutUsDetails?.aboutuscontent !== undefined) {
      //   sanitized = sanitizeHtml(response.data.aboutUsDetails.aboutuscontent);
      //   response.data.aboutUsDetails.aboutuscontent = sanitized;
      // }
      setAboutUs(response.data.aboutUsDetails);
      response.status === 202 &&
        showToast("About us details not found in the system", "error");
    } catch (error) {
      console.error(error);
      if (!error?.response) {
        showToast("No Server Response");
      } else if (error.response.status === 422) {
        showToast("Some of the required inputs were not provided", "error");
      } else {
        showToast(
          "Whoops!!!! This doesn't feel right. There might be an issue. Please contact administrator",
          "error"
        );
      }
    }
  };

  useEffect(() => {
    let isMounted = true;
    getAboutUsDetails();
    return () => {
      isMounted = false;
      controller.abort();
    };
  }, []);

  return (
    <Dashboard sidebarType={auth.rolename}>
      <ToastContainer />
      <div className="flex items-center justify-between">
        <H2withIcon>
          <IconContext.Provider value={{ className: "text-secondary" }}>
            <BsFillInfoCircleFill />
          </IconContext.Provider>
          &nbsp; About Us
        </H2withIcon>
        {!showAddForm && (
          <AddButton
            label={`${isEdit ? "Update About Us" : "Add About Us"}`}
            onclick={() => setShowAddForm(true)}
          />
        )}
      </div>
      {showAddForm ? (
        <AddAboutUs
          getAboutUsDetails={getAboutUsDetails}
          aboutUs={aboutUs}
          setAboutUs={setAboutUs}
          setShowAddForm={setShowAddForm}
        />
      ) : (
        <ContainerShadow>
          {!isEdit ? (
            <p>About us content is yet to be added</p>
          ) : (
            <div>
              <label>
                Short Summary: <br />
                <p className="text-justify">{aboutUs.shortsummary}</p>
              </label>
              <br />
              <label>
                About Us:
                <br />
              </label>
              <div
                dangerouslySetInnerHTML={{ __html: aboutUs.aboutuscontent }}
              />
            </div>
          )}
        </ContainerShadow>
      )}
    </Dashboard>
  );
};

export default AboutUs;
